import { Box, Button } from '@mui/material';
import ROUTES, { ACCOUNTS_CARDS_ROUTES } from 'app/constants/routes';

import BackIcon from '../../../components/Icons/BackIcon';

import { TFunction } from 'i18next';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import NonWorkingHours from '../../../pages/digital-account/ui/components/dialogs/off-hours';
import ExistingCustomerPage from '../../../pages/digital-account/ui/existing-customer/page';
import { useCustomNavigate } from '../../../utils/customHooks/useCustomNavigate';
import StepList from '../steps/ui/lists';
import { useOnboardingContext } from './onboarding.context';

const getSteps = (t: TFunction<'onboarding'>) => {
  return [
    {
      img: '/images/digital_account/select_accounts.png',
      label: t('onboarding:account_details'),
      path: 'currency',
    },
    {
      img: '/images/digital_account/business_query.png',
      label: t('onboarding:business_questions'),
      path: 'business-request',
    },
    {
      img: '/images/digital_account/sign_documents.png',
      label: t('onboarding:document_signing'),
      path: 'print-forms',
    },
  ];
};

const ExistingCustomerLayout = () => {
  const { t } = useTranslation('onboarding');
  const steps = useMemo(() => getSteps(t), [t]);
  const navigate = useCustomNavigate();
  const { state } = useOnboardingContext();

  const handleBack = () => {
    navigate(`${ROUTES.accountsCards.replace('/:lang/', '')}/${ACCOUNTS_CARDS_ROUTES.accounts}`);
  };

  const navigateToMainPage = () => {
    navigate(`${ROUTES.accountsCards.replace('/:lang/', '')}/${ACCOUNTS_CARDS_ROUTES.accounts}`);
  };

  const stepList = useMemo(() => {
    if (!state?.active) return steps;
    let foundedIndex = 0;

    steps.forEach((item, index) => {
      if (item.path === state.active) {
        foundedIndex = index;
      }
    });

    return steps.map((item, index) => ({
      ...item,
      isProgress: index <= foundedIndex,
      isCompleted: foundedIndex > index,
    }));
  }, [state?.active, steps]);

  return (
    <Box>
      <Box>
        <Button variant='outlined' color='secondary' startIcon={<BackIcon />} onClick={handleBack}>
          {t('open_an_account')}
        </Button>
      </Box>
      <Box sx={{ mt: 2 }}>
        <StepList
          list={stepList}
          sx={{ justifyContent: 'center', gap: 10 }}
          itemStyles={{ maxWidth: 300 }}
        />
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, maxWidth: 420, mx: 'auto' }}>
          <ExistingCustomerPage />
          <NonWorkingHours open={state.non_working_hours} navigate={navigateToMainPage} />
        </Box>
      </Box>
    </Box>
  );
};

export default ExistingCustomerLayout;
